export const OrderEnum = Object.freeze({
  asc: 'asc',
  desc: 'desc',
});
